/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SupportedDevices {
    None = 0,
    CardReaderMagTek = 1,
    CardReaderEMV = 2,
    CashAcceptor = 4,
    CheckReader = 8,
    ReceiptPrinter = 16,
    BarcodeScanner = 32,
    Camera = 64,
    LedControlBoard = 128,
}
